/**
 * 一种 await 的错误处理方式
 * @param {Promise} promise 异步操作
 * @param {Object} errorExt 错误信息
 */

function to(promise, errorExt) {
    return promise
        .then(data => [null, data])
        .catch(err => {
            // 如果有空的 Promise.reject();
            // 那么 err 为 undefined，后续的流程可能出错
            const error = err || new Error()

            if (errorExt) {
                Object.assign(error, errorExt)
            }

            return [error, undefined]
        })
}

function install(Vue) {
    if (install.installed) return
    install.installed = true

    Object.defineProperty(Vue.prototype, '$to', {
        get() {
            return to
        },
    })
}

export { to }

export default { install }
